import {ITestABGroup} from "services-comun-meteored/modules/services/cmp/web/resources";
import {TestAB} from "./test-a-b";

export class TestABGroup {
    /* STATIC */
    public static build(data: ITestABGroup): TestABGroup {
        return new TestABGroup(data);
    }

    /* INSTANCE */
    private constructor(private readonly _data: ITestABGroup) {
    }

    private get data(): ITestABGroup {
        return this._data;
    }

    public get testsAB(): TestAB[] {
        return this.data.tab.map(TestAB.build);
    }

    public appliedTestAB(factor: number): TestAB {
        const testAB = this.testsAB.find(testAB => testAB.spec.start_range <= factor && testAB.spec.end_range >= factor);
        if (!testAB) {
            if (this.testsAB.length) return this.testsAB[0];
            throw new Error(`No se ha encontrado un test AB para el factor ${factor}`);
        }
        return testAB;
    }
}
